import { render, staticRenderFns } from "./customerInformation.vue?vue&type=template&id=0fc7316c&scoped=true"
import script from "./customerInformation.vue?vue&type=script&lang=js"
export * from "./customerInformation.vue?vue&type=script&lang=js"
import style0 from "./customerInformation.vue?vue&type=style&index=0&id=0fc7316c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc7316c",
  null
  
)

export default component.exports